export default "__VITE_ASSET__BI1m70xD__"